import React, { useEffect, useState, useMemo } from 'react'
import { processChartData } from './utils'
import { getChartOptions, getChartDataConfig, chartPlugins } from './chartConfig'
import { OnTimeSubmissionReport } from '../../../../models/enhancement/on-time-submission-report'
import { ChartWrapper, useChart, useChartError } from '../common'
import { PeriodType } from '../../PeriodTypeSelector'

interface OnTimeSubmissionChartProps {
  readonly data: OnTimeSubmissionReport
  readonly isLoading: boolean
  readonly selectedRequestTypes?: string[] | null
  readonly periodType: PeriodType
}

function OnTimeSubmissionChart({ data, isLoading, selectedRequestTypes, periodType }: OnTimeSubmissionChartProps) {
  const chartRef = useChart()
  const { error, handleError, setError } = useChartError()
  const [chartData, setChartData] = useState<{
    labels: string[]
    actualValues: (number | null)[]
    targetValues: (number | null)[]
  }>({
    labels: [],
    actualValues: [],
    targetValues: []
  })

  const chartOptions = useMemo(
    () => getChartOptions(chartData.labels, chartData.actualValues, periodType),
    [chartData.labels, chartData.actualValues, periodType]
  )

  const chartDataConfig = useMemo(() =>
      getChartDataConfig(
        chartData.labels,
        chartData.actualValues,
        chartData.targetValues
      ),
    [chartData]
  )

  useEffect(() => {
    try {
      if (!data) return
      setChartData(processChartData(data, periodType))
      setError(null)
    } catch (err) {
      handleError(err, 'processing chart data')
    }
  }, [data, periodType, handleError, setError])

  const hasData = Boolean(
    data &&
    chartData.labels.length > 0 &&
    chartData.actualValues.some(value => value !== null && value !== undefined)
  )

  return (
    <ChartWrapper
      ref={chartRef}
      title="On Time Submission SLA (%)"
      error={error}
      isLoading={isLoading}
      hasData={hasData}
      chartType="line"
      chartData={chartDataConfig}
      chartOptions={chartOptions}
      chartPlugins={chartPlugins}
      height={500}
    />
  )
}

export default OnTimeSubmissionChart